/**
 * Force le passage de l'appli au premier plan
 */
export const moveToForeground = () => {
  const { backgroundMode } = cordova.plugins
  if (backgroundMode.isActive()) { // Appli en arriève plan
    // Turn screen on
    backgroundMode.wakeUp()
    // Turn screen on and show app even locked
    backgroundMode.unlock()
    backgroundMode.moveToForeground()
  }
}
